<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-pagination :theme="$otTheme"
                v-model="currentPage"
                :total="total"
                :pager-count="5"
                :page-size="pageSize"
                :page-sizes="pageSizes"
                show-page-sizes
                show-total
                show-jumper
                @changePage="changePage"
                background
                round >
            </ot-pagination>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            currentPage: 2,
            total: 100,
            pageSize: 10,
            pageSizes: [ 10, 50, 100 ],
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-pagination%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20v-model%3D%22currentPage%22%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Atotal%3D%22total%22%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Apager-count%3D%225%22%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Apage-size%3D%22pageSize%22%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Apage-sizes%3D%22pageSizes%22%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20show-page-sizes%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20show-total%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20show-jumper%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%40changePage%3D%22changePage%22%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20background%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20round%20%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-pagination%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20currentPage%3A%202%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20total%3A%20100%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20pageSize%3A%2010%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20pageSizes%3A%20%5B%2010%2C%2050%2C%20100%20%5D%2C%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%20%20%20%20methods%3A%20%7B%0A%20%20%20%20%20%20%20%20changePage()%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20console.log(this.currentPage)%3B%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
    methods: {
        changePage() {
            console.log(this.currentPage);
        },
    },
};
</script>
